import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CfFtDialogService {
  public slectedRowInTemplate = [];
  public constructor() {}

  public getSelectedRowInTemplateService(selRow: any): void {
    this.slectedRowInTemplate = selRow;
  }

  public setSelectedRowInTemplate(): any[] {
    return this.slectedRowInTemplate;
  }
}
